<template>
  <div class="tab-update-note-route">
    <ContentBlock>
      <div slot="instructions">
        <h5>{{ $t('Update Notes') }}</h5>
        <p>{{ $t('Enter the latest updates notes for your title here. These will be seen by operators in the marketplace.') }}</p>
      </div>
      <div>
        <TinyMCEEditor v-model="contentOwnership.updateNotes" :options="{height: 200}" />
      </div>
    </ContentBlock>
  </div>
</template>

<script>
import ContentBlock from '@/core/shared/components/ContentBlock';
import TinyMCEEditor from '@/content-ownership/show/components/content-fields/TinyMCEEditor';

export default {
  name: 'TabUpdateNoteRoute',
  components: {
    ContentBlock,
    TinyMCEEditor,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
};
</script>
